import AppMessage from '@/components/App/AppMessage.vue'

const Message = {
  install(Vue) {
    this.EventBus = new Vue()
    Vue.component('app-message', AppMessage)
    Vue.prototype.$message = {
      compose(params) {
        Message.EventBus.$emit('compose', params)
      }
    }
  }
}

export default Message